// libs
import { memo } from "react";
import styled from "@emotion/styled";

// mixins
import { resetButton } from "shared/styles/mixin";

const LinkButton = styled.button`
    ${resetButton}

    color: #000;
    border-bottom: solid 1px #000;
    font-weight: 500;
    cursor: pointer;
`;

export default memo(LinkButton);
